const LocalStorage = {
	removeSession: () => {
		localStorage.clear();
	},

	getAccessToken: () => {
		const authToken = localStorage.getItem('authToken');
		return authToken;
	},

	setAccessToken: (token) => {
		localStorage.setItem('authToken', token);
	},

	getRefreshToken: () => {
		return localStorage.getItem('refreshToken');
	},

	setRefreshToken: (token) => {
		localStorage.setItem('refreshToken', token);
	},

	getCurrentCustomer: () => {
		const currentCustomer = localStorage.getItem('currentCustomer');

		return currentCustomer;
	},

	setCurrentCustomer: (customerId) => {
		localStorage.setItem('currentCustomer', customerId);
	},
};

export default LocalStorage;
